import { render, staticRenderFns } from "./publish-vimeo.vue?vue&type=template&id=457e4de2&scoped=true&"
import script from "./publish-vimeo.vue?vue&type=script&lang=js&"
export * from "./publish-vimeo.vue?vue&type=script&lang=js&"
import style0 from "./publish-vimeo.vue?vue&type=style&index=0&id=457e4de2&scoped=true&lang=scss&"
import style1 from "./publish-vimeo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e4de2",
  null
  
)

export default component.exports